import {API_BASE_URL} from "../../config/constants";
import { postRequest } from '../API'
/*********************************************************
* Function Name : list
* Description   : Get list of notifications  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : details
* Description   : Get details of notification  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const details = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/details`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : sendNotification
* Description   : Send notification  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const sendNotification = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/send`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeReadStatus
* Description   : Change read status  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const changeReadStatus = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/change-read-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : Change status  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : deleteNotification
* Description   : Delete notification  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const deleteNotification = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : detailChangeReadStatus
* Description   : Details Change read status  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const detailChangeReadStatus = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/details/change-read-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : Change status  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const detailChangeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/details/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : deleteNotification
* Description   : Delete notification  
* By            : Afsar Ali
* Date          : 26-12-2025
*********************************************************/
export const detailDeleteNotification = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/details/delete`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : adminNotificationList
* Description   : Admin notification list  
* By            : Afsar Ali
* Date          : 26-1-2026
*********************************************************/
export const adminNotificationList = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/admin/notifications/admin/notification`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : readAllNotification
* Description   : Read all notification  
* By            : Afsar Ali
* Date          : 26-1-2026
*********************************************************/
export const readAllNotifications = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}front/v1/notifications/read-all`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteAllNotification
* Description   : Delete all notification  
* By            : Afsar Ali
* Date          : 26-1-2026
*********************************************************/
export const deleteAllNotification = async (options) =>{
    try {
        const params = {
            url : `${API_BASE_URL}front/v1/notifications/delete-all`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function